module.exports = __webpack_public_path__ + "static/img/2284_phase_function_Paper_Points.29999d1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/2284_phase_function_Paper_Points.png
// module id = Mc8d
// module chunks = 0